import Model from './utils/model'
import nexus from '@db2b/nexus-js'
import moment from 'moment'

export default {
  ...Model,
  options: {
    translations: {
      name: 'Upload'
    },
    name: 'upload',
    url: nexus.url('document2', 'uploads')
  }
}



// WEBPACK FOOTER //
// ./libs/@db2b/keystone/model/upload.js